<!-- Séquençage V2 — Loader/progress de la cascade visible pour les DEUX parcours
     (legacy + V2). Sorti de l'aiguillage pour rester visible pendant `regenerateDocuments()`. -->
@if (loading) {
  <div style="max-height: none; margin-top: 1rem; position: relative">
    <pr-loader style="max-height: 0rem; margin-top: 7rem"></pr-loader>
    <div class="progress">
      <div class="progress-bar" [style.width.%]="progress"></div>
    </div>
    <p class="loader-documents-message">{{ loadingMessage }}</p>
  </div>
}

<!-- Séquençage V2 — Blocs d'erreur sortis de l'aiguillage : la cascade d'arrivée
     (regenerateDocuments) est commune legacy + V2, donc ses erreurs — dont
     PRE_VERIFICATION_EXTERNAL_API — doivent s'afficher pour les deux parcours.
     Avant, ils étaient enfermés dans le @else (legacy) et invisibles en V2. -->
@if (swisslifePledgeRuleErrors?.length) {
  <div class="mb-4">
    <div class="alert alert-danger">
      <p>
        <strong
          >Échec de la validation des règles de gestion, merci d'effectuer les
          modifications :</strong
        >
      </p>
      <ul>
        @for (error of swisslifePledgeRuleErrors; track error) {
          <li>
            {{ error }}
          </li>
        }
      </ul>
    </div>
  </div>
}

@if (swisslifePledgeRuleErrors?.length) {
  <div class="mb-4">
    <info [option]="optionInfo3">
      <p>
        <strong>Important : Rappel du marché cible</strong>
      </p>
      <ul>
        @for (error of swisslifeMarcheCible; track error) {
          <li>
            {{ error }}
          </li>
        }
      </ul>
    </info>
  </div>
}
@if (pledgeLcbFtErrors) {
  <div class="mb-4">
    <div class="alert alert-danger">
      <p>
        <strong
          >Échec de la validation des règles LCB-FT, merci de rentrer en contact
          avec l'équipe conformité pour résoudre les problèmes suivants
          :</strong
        >
      </p>
      <ul>
        <li>
          {{ pledgeLcbFtErrors }}
        </li>
      </ul>
    </div>
  </div>
}
@if (
  internalError &&
  !preVerificationApiError &&
  !preVerificationUniversignError &&
  !swisslifePledgeRuleErrors?.length &&
  !pledgeLcbFtErrors
) {
  <div class="mb-4">
    <div class="alert alert-danger">
      <p>
        <strong>{{ internalError }}</strong>
      </p>
    </div>
  </div>
}
@if (preVerificationApiError) {
  <div class="mb-4">
    <div class="alert alert-danger">
      <p>
        <strong>{{ preVerificationApiError }}</strong>
      </p>
    </div>
  </div>
}
@if (preVerificationUniversignError) {
  <div class="mb-4">
    <div class="alert alert-danger">
      <p>
        <strong>{{ preVerificationUniversignError }}</strong>
      </p>
    </div>
  </div>
}

<!-- Séquençage V2 — Aiguillage parcours : V2 → écran « réutiliser / regénérer » ;
     legacy → écran existant d'édition Froala packReglementaireHtml. -->
@if (pledge?.legacyFlow === false) {
  @if (
    !loading &&
    !internalError &&
    !preVerificationApiError &&
    !preVerificationUniversignError &&
    !swisslifePledgeRuleErrors?.length &&
    !pledgeLcbFtErrors
  ) {
    <pack-builder
      [pledge]="pledge"
      (next)="onV2Next($event)"
      (prev)="onV2Prev()"
    ></pack-builder>
  }
} @else {
  @if (
    !loading &&
    operation === 'SUBSCRIPTION' &&
    !sequencageDisabled &&
    needSequencage &&
    needSequencageMessage
  ) {
    <div class="mb-4">
      <pr-button
        size="lg"
        display="neutral"
        (onClick)="regeneratePackReglementaire()"
        label="Regénérer le pack réglementaire"
      />
    </div>
  }
  @if (
    !loading &&
    needSequencage &&
    !needSequencageMessage &&
    !sequencageDisabled &&
    operation === 'SUBSCRIPTION'
  ) {
    <info [option]="optionInfo1">
      Vous ne disposez pas d'un <b>pack réglementaire</b> signé pour ce profil
      investisseur datant de plus de 48 heures et de moins d'un an. <br />
      Un premier lien de signature comprenant le pack réglementaire sera envoyé.
      <br />
      Un deuxième lien de signature sera envoyé 48 heures après la signature du
      <b>pack réglementaire</b> avec le reste des documents.
    </info>
  }
  @if (
    !loading &&
    needSequencage &&
    needSequencageMessage &&
    !sequencageDisabled &&
    operation === 'SUBSCRIPTION'
  ) {
    <info [option]="optionInfo1">
      {{ needSequencageMessage }}
    </info>
  }
  @if (
    !loading &&
    !needSequencage &&
    !sequencageDisabled &&
    operation === 'SUBSCRIPTION'
  ) {
    <info [option]="optionInfo2">
      Vous disposez d'un <b>pack réglementaire</b> à jour et signé pour ce
      profil investisseur. <br />
      Les documents de souscription seront directement envoyés lors de l'envoi
      en signature électronique.
    </info>
  }
  <!-- Séquençage V2 — Blocs d'erreur remontés en tête du template, partagés legacy + V2. -->

  <pr-modal-confirm
    display="warning"
    title="Alertes LCB"
    labelConfirm="Fermer"
    labelCancel="Retour"
    (onConfirm)="closeModalLcbFt()"
  >
    <ul>
      @for (warning of warningsFields; track warning) {
        <li class="di-info-product mb-1">
          <pr-icon name="fa-warning" size="sm" style="color: #f0ad4e"></pr-icon>
          <span class="di-label-product">{{ warning }}</span>
        </li>
      }
    </ul>
  </pr-modal-confirm>

  <!-- Étape lecture des process -->
  @if (!loading && showProcessStep) {
    <div class="mt-8">
      <info [option]="optionInfo3"
        >Veuillez lire attentivement le(s) process de souscription ci-dessous
        avant de continuer.
      </info>
      @for (item of productProcesses; track item; let i = $index) {
        <div
          class="mb-6 overflow-hidden rounded-2xl border border-gray-300 shadow-sm"
        >
          <div
            class="header-doc flex cursor-pointer items-center justify-between bg-gray-100 px-4 py-3"
            (click)="toggleProcessDropdown(i)"
          >
            <div class="font-medium">{{ item.productName | uppercase }}</div>
            <pr-icon
              [name]="
                openProcessDropdowns[i] ? 'fa-chevron-up' : 'fa-chevron-down'
              "
              size="sm"
            ></pr-icon>
          </div>
          @if (openProcessDropdowns[i]) {
            <div class="bg-white p-4">
              <app-froala-editor
                [formControl]="processesArray.at(i)"
                [readonly]="true"
              ></app-froala-editor>
            </div>
          }
        </div>
      }
      <div
        class="mt-6 flex cursor-pointer items-center gap-3"
        (click)="processConfirmed = !processConfirmed"
      >
        <div class="check-circle" [class.checked]="processConfirmed">
          @if (processConfirmed) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-4 w-4 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              stroke-width="3"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          }
        </div>
        <span class="font-medium"
          >Je confirme avoir lu
          {{ (productProcesses?.length || 0) > 1 ? 'les' : 'le' }} process de
          souscription.</span
        >
      </div>
    </div>
  }

  @if (!loading && showProcessStep) {
    <form-footer
      (prev)="prev()"
      (next)="confirmProcessRead()"
      [disabledNext]="!processConfirmed"
      [disabledSkip]="true"
    ></form-footer>
  }

  <!-- Étape vérification des documents -->
  @if (!loading && !showProcessStep) {
    <div class="mt-8">
      <form [formGroup]="form" class="form-docs">
        <info [option]="optionInfo3"
          >Vous avez la possibilité de modifier les documents réglementaires de
          votre souscription/opération. <br />
          Cochez sur la case à cocher pour les valider et pouvoir passer à la
          question suivante.
        </info>
        <div
          class="header-doc mb-4 flex cursor-pointer items-center justify-between rounded-2xl bg-gray-100 px-4 py-3 shadow-sm"
          [ngClass]="{ 'document-checked': allDocsValidated() }"
          (click)="toggleAllValidations()"
        >
          <div class="flex items-center gap-3">
            <div class="check-circle" [class.checked]="allDocsValidated()">
              @if (allDocsValidated()) {
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-4 w-4 text-white"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  stroke-width="3"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              }
            </div>
            <div class="font-medium">Valider tous les documents</div>
          </div>
        </div>
        @for (item of editableDocs; track item; let i = $index) {
          <div
            class="mb-4 overflow-hidden rounded-2xl border border-gray-300 shadow-sm"
          >
            <div
              class="header-doc flex cursor-pointer items-center justify-between bg-gray-100 px-4 py-3"
              [ngClass]="{ 'document-checked': validatedDocs[i] }"
              (click)="toggleDropdown(i)"
            >
              <div class="flex items-center gap-3">
                <div
                  class="check-circle"
                  [class.checked]="validatedDocs[i]"
                  (click)="$event.stopPropagation(); toggleValidation(i)"
                >
                  @if (validatedDocs[i]) {
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-white"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      stroke-width="3"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  }
                </div>
                <div class="font-medium">
                  {{ item.title }}
                </div>
              </div>
              <pr-icon
                [name]="openDropdowns[i] ? 'fa-chevron-up' : 'fa-pencil'"
                size="sm"
              ></pr-icon>
            </div>
            @if (openDropdowns[i]) {
              <div class="bg-white p-4">
                <app-froala-editor
                  [formControl]="docsArray.at(i)"
                  [toolbarButtons]="toolbarButtons"
                ></app-froala-editor>
              </div>
            }
          </div>
        }
      </form>
    </div>
  }

  @if (!loading && !showProcessStep) {
    <form-footer
      (prev)="prev()"
      (next)="saveEditedDocuments()"
      [disabledNext]="
        !allDocsValidated() ||
        swisslifePledgeRuleErrors?.length ||
        pledgeLcbFtErrors ||
        internalError ||
        !pledge?.parameters?.packSouscriptionHtml?.length
      "
      [disabledSkip]="true"
    ></form-footer>
  }
}
